import { InvoiceSendingTypeIntegerEnum } from 'src/shared/models/enums/invoiceSendingTypeInteger.enum';
import { InvoiceSendingTypeStringEnum } from 'src/shared/models/enums/InvoiceSendingTypeString.enum';

const convertSendingTypeIntToStringMap: Record<InvoiceSendingTypeIntegerEnum, InvoiceSendingTypeStringEnum | null> = {
  [InvoiceSendingTypeIntegerEnum.NotSet]: null,
  [InvoiceSendingTypeIntegerEnum.Email]: InvoiceSendingTypeStringEnum.emailinvoice,
  [InvoiceSendingTypeIntegerEnum.Main]: InvoiceSendingTypeStringEnum.invoice,
  [InvoiceSendingTypeIntegerEnum.Reminder1]: InvoiceSendingTypeStringEnum.reminder1,
  [InvoiceSendingTypeIntegerEnum.Reminder2]: InvoiceSendingTypeStringEnum.reminder2,
  [InvoiceSendingTypeIntegerEnum.Card]: InvoiceSendingTypeStringEnum.card,
  [InvoiceSendingTypeIntegerEnum.EmailReminder]: InvoiceSendingTypeStringEnum.emailreminder,
  [InvoiceSendingTypeIntegerEnum.Sms]: InvoiceSendingTypeStringEnum.sms,
  [InvoiceSendingTypeIntegerEnum.SmsReminder]: InvoiceSendingTypeStringEnum.smsreminder,
} as const;

const convertSendingTypeStringToIntMap: Record<InvoiceSendingTypeStringEnum, InvoiceSendingTypeIntegerEnum> = {
  [InvoiceSendingTypeStringEnum.emailinvoice]: InvoiceSendingTypeIntegerEnum.Email,
  [InvoiceSendingTypeStringEnum.invoice]: InvoiceSendingTypeIntegerEnum.Main,
  [InvoiceSendingTypeStringEnum.reminder1]: InvoiceSendingTypeIntegerEnum.Reminder1,
  [InvoiceSendingTypeStringEnum.reminder2]: InvoiceSendingTypeIntegerEnum.Reminder2,
  [InvoiceSendingTypeStringEnum.card]: InvoiceSendingTypeIntegerEnum.Card,
  [InvoiceSendingTypeStringEnum.emailreminder]: InvoiceSendingTypeIntegerEnum.EmailReminder,
  [InvoiceSendingTypeStringEnum.sms]: InvoiceSendingTypeIntegerEnum.Sms,
  [InvoiceSendingTypeStringEnum.smsreminder]: InvoiceSendingTypeIntegerEnum.SmsReminder,
} as const;

export const convertSendingTypeIntToString = (value: InvoiceSendingTypeIntegerEnum): InvoiceSendingTypeStringEnum | null =>
  convertSendingTypeIntToStringMap[value];

export const convertSendingTypeStringToInt = (value: InvoiceSendingTypeStringEnum): InvoiceSendingTypeIntegerEnum =>
  convertSendingTypeStringToIntMap[value];
